import { render, staticRenderFns } from "./managementFee.vue?vue&type=template&id=479fe2ce&scoped=true&"
import script from "./managementFee.vue?vue&type=script&lang=js&"
export * from "./managementFee.vue?vue&type=script&lang=js&"
import style0 from "./managementFee.vue?vue&type=style&index=0&id=479fe2ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479fe2ce",
  null
  
)

export default component.exports